/* global BigInt */
export const roundStaking = (value) => {
  const splits = value.toString().split('.');
  const transformed = splits[0] + '.' + (splits[1] ? splits[1].substring(0, 5) : '0');
  return BigInt(Math.floor(transformed * 100000)) * BigInt(1e13);
}